import { Edit, useForm, useSelect } from "@refinedev/antd";
import { Form, Input, Select, Tag, Space } from "antd";
import { IResourceComponentsProps } from "@refinedev/core";
import { DesktopOutlined } from "@ant-design/icons";

import { IEcdis, IVessel } from "interfaces";
import React from "react";
import { FormSection, FormFieldGrid } from "components/form";

export const EcdisEdit: React.FC<IResourceComponentsProps> = () => {
  const {
    formProps,
    saveButtonProps,
    query,
    formLoading: isLoading,
  } = useForm<IEcdis>();

  function VesselSelectComponent() {
    const { selectProps } = useSelect<IVessel>({
      resource: "vessel",
      optionLabel: "imoNumber",
      optionValue: "id",

      filters: query?.data?.data?.vessel?.id
        ? [
            {
              field: "id",
              operator: "eq",
              value: query?.data?.data?.vessel?.id,
            },
          ]
        : [],

      pagination: {
        mode: "server"
      }
    });
    return (
      <Form.Item
        label="IMO Number"
        name={["vessel", "id"]}
        rules={[
          {
            required: true,
          },
        ]}
        initialValue={query?.data?.data?.vessel?.imoNumber}
      >
        <Select {...selectProps} disabled />
      </Form.Item>
    );
  }

  return (
    <Edit
      breadcrumb={false}
      saveButtonProps={saveButtonProps}
      headerProps={{
        onBack: () => window.history.back(),
        title: "Edit ECDIS",
        subTitle: "edit ECDIS",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form {...formProps} layout="vertical">
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="ECDIS Information"
            subtitle="Electronic Chart Display and Information System details"
            icon={<DesktopOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={2}>
              <Form.Item
                label="Make"
                name="make"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Model"
                name="model"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              {query?.isSuccess ? (
                <VesselSelectComponent />
              ) : null}
            </FormFieldGrid>
          </FormSection>
        </Space>
      </Form>
    </Edit>
  );
};
